module.exports = __webpack_public_path__ + "static/media/cloud.80f89a6e.png";